import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import commonPropTypes from '../../../constants/commonPropTypes'
import { formFieldWrapper } from '../formFieldWrapper'

class BaseInputField extends Component {
  static propTypes = {
    ...commonPropTypes,
    inputLabel: PropTypes.string,
    normalizeOnBlur: PropTypes.func,
    compact: PropTypes.bool,
  }

  static defaultProps = {
    fluid: true,
    compact: false,
  }

  render() {
    const {
      elmId,
      value,
      onChange,
      onBlur,
      placeholder,
      inputLabel,
      normalizeOnBlur,
      normalizeOnChange,
      showError,
      fluid,
      compact,
      className,
      guide, // eslint-disable-line no-unused-vars
      ...rest
    } = this.props

    const onChangeNew = e => {
      if (normalizeOnChange) {
        e.target.value = normalizeOnChange(e.target.value)
      }
      onChange && onChange(e)
    }

    const onBlurNew = e => {
      if (normalizeOnBlur) {
        e.target.value = normalizeOnBlur(e.target.value)
      }
      onBlur && onBlur(e)
    }

    const newClassName = classnames({
      compact,
      [className]: !!className,
    })

    const finalValue = _.isNil(value) ? '' : String(value)

    return (
      <Input
        aria-label={`${elmId}_input`}
        data-elm-id={`${elmId}_input`}
        className={newClassName}
        onChange={onChangeNew}
        value={finalValue}
        onBlur={onBlurNew}
        error={showError}
        placeholder={placeholder}
        label={inputLabel}
        fluid={fluid}
        {...rest}
      />
    )
  }
}

export default formFieldWrapper((fieldProps, showError) => (
  <BaseInputField {...fieldProps} showError={showError} />
))
